<template>
  <v-row align="center" justify="center" class="pa-2">
    <v-card max-width="80%" width="500" flat color="background">
      <v-row align="center" justify="center">
        <v-row class="d-flex">
          <h1 class="mb-4 p-a2">Preguntas frecuentes</h1>
        </v-row>
        <v-row align="center" justify="center">
          <v-expansion-panels>
            <v-expansion-panel v-for="(question,i) in questions" :key="i">
              <v-expansion-panel-header @click="questionClick()">
                {{ question.pregunta }}
                <template v-slot:actions>
                  <v-icon x-large color="primary">mdi-plus</v-icon>
                </template>
              </v-expansion-panel-header>
              <v-expansion-panel-content color="#E5EAF0">{{ question.respuesta }}</v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-row>
      </v-row>
    </v-card>
  </v-row>
</template>

<script>
import questions from "../statics/frecuentQuestions.json";
var mixpanel = require('mixpanel-browser');
import config from "../config"
mixpanel.init(config.key);

export default {
  data() {
    return {
      questions,
    };
  },
  methods: {
    questionClick() {
      mixpanel.track('Click FAQ');
    },
  },
};
</script>

<style scoped>
.textColor {
  color: #646afa;
}
</style>